import React, { useState } from "react";
import { CommonModal } from "../../AbstractElements";
import { Row, Col, FormGroup, Label, Form } from "reactstrap";
import { showAlert } from "../../Services/Shared.service";
import { blockDriver } from "../../Services/Driver.service";
import { useController, useForm } from "react-hook-form";

const UnblockConformation = ({ Large, title, LargeModaltoggle, driverObj, fetchDriverData }) => {
 
  const {
    register,
    handleSubmit,
    control,
    reset,
    resetField,
    getValues,
    setValue,
    watch,
    formState: { errors },
  } = useForm({
    reason: null,
    driverId:driverObj.id? driverObj.id.toString(): null,
    unblockedReason:""
  });
  const [isSubmitting, setIsSubmitting] = useState(false); 
  const onUnBlockDriverSubmit = (formValues) => {

    if (isSubmitting) return;
    setIsSubmitting(true);
    let obj = {
      reason: null,
      driverId: driverObj.id.toString(),
      unblockedReason:formValues.unblockedReason
    };
    blockDriver(obj).then(async (result) => {
      showAlert('success', "Driver unblocked successfully")
      await fetchDriverData()
      LargeModaltoggle();

    }).catch(err => {
      showAlert('error', err.response?.data?.message
        ? err.response.data.message : 'Something went wrong')
    }).finally(() => {
      setIsSubmitting(false); 
    });
  };
  return (
    <CommonModal
      isOpen={Large}
      title={title}
      toggler={LargeModaltoggle}
      size="md"
    >  <Form onSubmit={handleSubmit(onUnBlockDriverSubmit)}>
      <Row className="driver-push-notification">
        <Col xl="12" className="push-botification-body">
          <div className="text-center">Are you sure you want to unblock this driver ?</div>
        </Col>
        <FormGroup className="row col-lg-12">
            <Label className="col-lg-12 col-form-label">Unblock Reason</Label>
            <Col lg="12">
              <textarea
                className="form-control"
                {...register("unblockedReason", {
                  required: {
                    value: true,
                     message: "Unblock Reason is required"
                  }, maxLength: {
                    value: 30,
                    message: "Reason cannot exceed 30 characters",
                },pattern: {
                  value: /^[A-Za-z\s]*$/,
                  message: "Reason can only contain letters and spaces",
              },
                validate: (value) => value.trim() !== "" || "Reason cannot be empty or contain only spaces"
              
                })}
                type="text"
              />
               <span style={{ color: "red" }}>{errors?.unblockedReason?.message}</span>
            </Col>
          </FormGroup>
        <Col xl="12" className="push-notification-footer">
          <button
            className="btn btn-primary"
            type="submit"
            disabled={isSubmitting}
          >
             {isSubmitting ? "Submitting..." : "Confirm"}
          </button>
        </Col>
      </Row>
      </Form>
    </CommonModal>
  );
};

export default UnblockConformation;
